import React from 'react'
import { MessengerButton } from '../../buttons/MessengerButton/MessengerButton'
import {
    StyledFooterContent,
    StyledBlock,
    StyledList,
    StyledBlockHeader,
    StyledLink,
    StyledTitle,
    StyledText,
} from '../../navigation/TheWestFooterNetworkLinks/TheWestFooterNetworkLinks.styled'
import { SocialLinks } from '../../navigation/SocialLinks/SocialLinks'
import {
    theWestSectionDefinitions,
    TheWestSection,
} from '../../__styling/settings/sections/thewest'
import { useTheme } from '@emotion/react'
import { isComponentEnabled } from '@news-mono/web-common'
import { useToggleState } from '@news-mono/web-common'
import {
    TheWestFooterNetworkLinksProps,
    BaseSocial,
    Address,
} from './TheWestFooterNetworkLinks'
import { toFeatureState } from '@etrigan/feature-toggles-client'

export const TheWestFooterNetworkLinksWeb: React.FC<TheWestFooterNetworkLinksProps> = ({
    networkLinks,
    socialLinks,
}) => {
    const { section } = useTheme()
    const featureState = useToggleState()

    const isRegionalSite = section !== 'default'
    const linksToDisplay = isRegionalSite
        ? networkLinks.regional
        : networkLinks.thewest

    const renderSocialLinks = () => {
        if (isRegionalSite) {
            if (!socialLinks[section as TheWestSection]) {
                return
            }

            const sectionedSocialLinks = socialLinks[
                section as TheWestSection
            ] as BaseSocial & Address

            const {
                street,
                city,
                state,
                postcode,
                phone,
            } = sectionedSocialLinks
            const { title } = theWestSectionDefinitions[
                section as TheWestSection
            ]

            return (
                <StyledBlock>
                    <StyledBlockHeader>Contact Us</StyledBlockHeader>
                    <StyledTitle>{title}</StyledTitle>
                    <StyledText>
                        {street}<br />
                        {`${city} ${state} ${postcode}`}<br />
                        {`Tel ${phone}`}
                    </StyledText>
                    <MessengerButton
                        link={sectionedSocialLinks.facebookMessenger}
                    />
                    <SocialLinks {...sectionedSocialLinks} />
                </StyledBlock>
            )
        }

        return (
            <StyledBlock>
                <StyledBlockHeader>Connect with us</StyledBlockHeader>
                <MessengerButton link={socialLinks.default.facebookMessenger} />
                <SocialLinks {...socialLinks.default} />
            </StyledBlock>
        )
    }

    return (
        <StyledFooterContent>
            {linksToDisplay.map((item) => {
                return (
                    <StyledBlock key={item.name}>
                        <StyledBlockHeader>{item.name}</StyledBlockHeader>
                        <StyledList>
                            {item.links
                                .filter(({ feature }) =>
                                    isComponentEnabled(
                                        toFeatureState(featureState),
                                        feature,
                                    ),
                                )
                                .map(({ name, link }) => {
                                    return (
                                        <li key={name}>
                                            <StyledLink to={link}>
                                                {name}
                                            </StyledLink>
                                        </li>
                                    )
                                })}
                        </StyledList>
                    </StyledBlock>
                )
            })}
            {renderSocialLinks()}
        </StyledFooterContent>
    )
}
TheWestFooterNetworkLinksWeb.displayName = 'TheWestFooterNetworkLinks'
